<template>
    <b-row>
        <b-col cols="12">
            <b-table
                striped
                hover
                :items="subscriptor.grupos"
                :fields="[
                    { key: 'id', label: 'ID' },
                    { key: 'nombre', label: 'Nombre' },
                    { key: 'descripcion', label: 'Descripción' },
                    { key: 'opciones', label: 'Opciones' }
                ]"
                show-empty
            >
                <template #empty>
                    <h4 class="text-center">No hay ningún resultado</h4>
                </template>
                <template #cell(opciones)="data">
                    <b-button :to="{ name: 'back.emails.grupos.show', params: { grupo_id: data.item.id } }" size="sm">
                        Ver grupo
                    </b-button>
                </template>
            </b-table>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: 'GruposTab',
        props: {
            subscriptor: {
                type: Object,
                required: true
            }
        }
    };
</script>